export default __webpack_public_path__ + "static/media/CV_2026.4d58c71c.pdf";